



























































import { Component, Vue, Watch } from "vue-property-decorator";
import { AppConstants, Models, apiService, Interfaces } from "@/core/Export";
import SignaturePad from "signature_pad";
import AppForm1312 from "@/components/AppForm1312.vue";
import { date } from "quasar";
import $ from "jquery";
import store from "@/store";
@Component({
  components: { AppForm1312 },
})
export default class GreenRouteFormPage extends Vue {
  isSignDialogVisible: boolean = false;
  signaturePad: any = null;
  signatureCanvasElm: any = null;
  signatureImgSrc: any = null;
  poupWidth = 718;
  saveTRequestModel: any = {};
  saveTRequestModelCopy: any = {};
  isSendRequestButtonPressed: boolean = false;
  isRequestDataReady: boolean = false;

  constructor() {
    super();
  }

  created() {
    this.onGetNewRequestData();
  }

  onGetNewRequestData() {
    this.isRequestDataReady = false;
    this.appEnv.isBusy = true;
    apiService
      .post("Request/CreateNewRequest", {
        personId: this.appEnv.requestParams.personId,
        year: this.appEnv.requestParams.year,
      })
      .then((res) => {
        let response = res as Interfaces.ICallResult;
        if (response && response.isSuccess) {
          this.tRequestModel = response.result;        

          this.onSetRequestFormDefaults(this.tRequestModel.requestDto.city);
          this.onConvertModelDates();
          this.isRequestDataReady = true;
        } else {
          this.appEnv.showErrorDialog(response.msgs.errors);
        }
      })
      .catch((err) => {})
      .finally(() => {
        this.appEnv.isBusy = false;
      });
  }

  onSendRequestForm(e, isDraft: boolean) {
    e.preventDefault();
    this.isSendRequestButtonPressed = true;
    let requestForm = this.$refs.AppForm1312["$refs"].requestForm as any;
    requestForm.validate().then((success) => {
      if (success && !this.isSignaturePadEmpty) {
        this.onSave();
      } else {
        this.$q.notify({
          color: "negative",
          message: "ישנם שדות חובה שלא מילאת",
          icon: "warning",
          position: "center",
          actions: [{ icon: "close", color: "white", handler: () => {} }],
        });
      }
    });
  }

  onSave() {
    this.onPrepareRequestForSave(false);
    store.commit("updateTRequestModel", this.saveTRequestModelCopy);
    this.appEnv.canViewRequestRouteGreenPage = true;
    this.$router.push({
      name: AppConstants.Routes.GreenRoute,
      query: { isFrom1312Form: "true" },
    });
  }

  onPrepareRequestForSave(isDraft: boolean) {
    this.saveTRequestModel = Object.assign(this.saveTRequestModel, this.tRequestModel.requestDto);
    this.saveTRequestModel.isDraft = isDraft;

    let dob = this.appEnv.toUTC(this.saveTRequestModel.requestFormObj.dob);
    let residentFromDate = this.appEnv.toUTC(
      this.saveTRequestModel.requestFormObj.residentFromDate
    );
    let fillFormDate = this.appEnv.toUTC(
      this.saveTRequestModel.requestFormObj.fillFormDate
    );

    if (this.saveTRequestModel.requestFormObj.partnerDob) {
      let partnerDob = this.appEnv.toUTC(
        this.saveTRequestModel.requestFormObj.partnerDob
      );
      if (partnerDob) {
        this.saveTRequestModel.requestFormObj.partnerDob = partnerDob;
      }
    }

    if (dob) {
      this.saveTRequestModel.requestFormObj.dob = dob;
    }

    if (residentFromDate) {
      this.saveTRequestModel.requestFormObj.residentFromDate = residentFromDate;
    }

    if (fillFormDate) {
      this.saveTRequestModel.requestFormObj.fillFormDate = fillFormDate;
    }

    let existChilds = this.saveTRequestModel.requestFormObj.children;
    this.saveTRequestModel.requestFormObj.children = [];
    existChilds.forEach((child) => {
      if (
        child.firstName &&
        child.idNo &&
        child.dob &&
        child.city &&
        child.educationInstName
      ) {
        let childDob = this.appEnv.toUTC(child.dob);
        if (childDob) {
          child.dob = childDob;
        }
        this.saveTRequestModel.requestFormObj.children.push(child);
      }
    });

    this.saveTRequestModelCopy = JSON.parse(JSON.stringify(this.saveTRequestModel));
  }

  onCloseSignDialog(isApprove) {
    if (isApprove) {
      this.signatureImgSrc = this.signaturePad.toDataURL("image/png");
      this.tRequestFormData.signature = this.signaturePad.toData();
    }
    this.isSignDialogVisible = false;
  }

  onOpenSignDialog() {
    this.isSignDialogVisible = true;
    setTimeout(() => {
      this.signatureCanvasElm = document.getElementById("signature_pad");
      this.signaturePad = new SignaturePad(this.signatureCanvasElm);
      this.poupWidth = $(".sign_dialog").width() - 32;
    }, 0);
  }

  onConvertModelDates() {
    let dob = this.formatDate(this.tRequestFormData.dob);
    let residentFromDate = this.formatDate(this.tRequestFormData.residentFromDate);
    let fillFormDate = this.formatDate(this.tRequestFormData.fillFormDate);
    let partnerDob = this.formatDate(this.tRequestFormData.partnerDob);

    if (dob) {
      this.tRequestFormData.dob = dob;
    }

    if (residentFromDate) {
      this.tRequestFormData.residentFromDate = residentFromDate;
    }

    if (fillFormDate) {
      this.tRequestFormData.fillFormDate = fillFormDate;
    }

    if (partnerDob) {
      this.tRequestFormData.partnerDob = partnerDob;
    }

    if (this.tRequestFormData.children) {
      this.tRequestFormData.children.forEach((child) => {
        child.dob = this.formatDate(child.dob);
      });
    } else {
      this.tRequestFormData.children = new Array<Models.TChildren>();
      this.addChildLine();
    }
  }

  extractDate(value) {
    if (value) return date.extractDate(value, "DD/MM/YYYY");
  }

  formatDate(value) {
    if (value) return date.formatDate(value, "DD/MM/YYYY");
  }

  onSetRequestFormDefaults(city:string) {
    this.tRequestFormData.children = new Array<Models.TChildren>();
    if (!city) {
      this.tRequestFormData.city = this.authorityName;
    }else{
      this.tRequestFormData.city = city; 
    }
    this.tRequestFormData.fillFormDate = new Date();
    this.addChildLine();
  }

  addChildLine() {
    let child = new Models.TChildren();
    child.id = this.tRequestFormData.children.length + 1;
    this.tRequestFormData.children.push(child);
  }

  get isSignaturePadEmpty() {
    if (this.signaturePad) {
      return this.isSendRequestButtonPressed && this.signaturePad.isEmpty();
    } else {
      return this.isSendRequestButtonPressed;
    }
  }

  get authorityName() {
    if (this.systemData && this.systemData["systemSettings"]) {
      return this.systemData["systemSettings"].authorityName;
    } else {
      return;
    }
  }

  set tRequestModel(values) {
    store.commit("updateTRequestModel", values);
  }

  get tRequestModel() {
    return store.getters.tRequestModel;
  }

  get tRequestFormData() {
    return this.tRequestModel.requestDto.requestFormObj
  }

  get systemData() {
    return store.getters.systemData;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
